<!--
 * @Description: 角色管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-25 13:14:40
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-12-13 16:10:03
 -->
<template>
  <div class="roleMana">
    <div class="searchContainer">
      <div class="searchItem">
        <span class="searchTitle">角色名称：</span>
        <el-input v-model="searchName" placeholder="请输入角色名称"></el-input>
      </div>
      <div class="searchItem">
        <span class="searchTitle">角色状态：</span>
        <el-select v-model="searchState" :disabled="dialogType === 'detail'" placeholder="请选择角色状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
      <el-button class="searchButton" type="primary" round @click="search">查询</el-button>
    </div>
    <!-- 列表 -->
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">角色管理</div>
        <div class="handleArea">
          <el-button class="addButton" type="danger" round @click="add">新增</el-button>
        </div>
      </div>
      <div class="list">
        <el-table
          :data="listData">
          <el-table-column
            align="center"
            prop="name"
            label="角色名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="description"
            label="角色描述">
          </el-table-column>
          <el-table-column
            align="center"
            v-slot="{row: { state }}"
            label="角色状态">
            <div :class="state ? 'normal' : 'abnormal'">
              {{state ? '启用' : '禁用'}}
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            width="300"
            v-slot="{row}"
            label="操作">
            <div class="handle">
              <span class="detail" @click='showDetail(row)'>详情</span>
              <span class="modify" @click='modify(row)'>编辑</span>
              <span class="distributionResources" @click='distributionResources(row)'>分配资源</span>
              <span class="delete" @click='deleteHandle(row)'>删除</span>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <BasePagination
          :total="total"
          :page-size="pageSize"
          :current-page="pageIndex"
          background
          @pagination="currentChange"
        />
      </div>
    </div>
    <!-- 新增角色 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>角色名称：</span>
          <el-input v-model="name" :maxlength="18" :disabled="dialogType === 'detail'" placeholder="请输入角色名称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">角色描述：</span>
          <el-input v-model="description" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入角色描述"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>角色状态：</span>
          <el-select v-model="state" :disabled="dialogType === 'detail'" placeholder="请选择角色状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>排序：</span>
          <el-input v-model="sort" type="number" :disabled="dialogType === 'detail'" placeholder="请输入排序号"></el-input>
        </div>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增角色 弹框 end -->
    <!-- 分配资源弹框 start -->
    <el-dialog
      class="distributionUserResourcesDialog"
      @closed="distributionResourcesDialogClosed"
      title="分配资源"
      :visible.sync="distributionResourcesDialogVisible">
      <div class="content">
        <el-tree
          :data="resourcesOptions"
          show-checkbox
          @check="resourcesSelectChange"
          :check-strictly="true"
          node-key="id"
          :default-expand-all="true"
          :default-checked-keys="selectedResources"
          :props="resourcesDefaultProps">
        </el-tree>
      </div>
      <div class="handleBtn">
        <el-button type="primary" @click="confirmDistributionResources">确认</el-button>
        <el-button type="danger" @click="cancelDistributionResources">取消</el-button>
      </div>
    </el-dialog>
    <!-- 分配资源弹框 end -->
  </div>
</template>

<script>
import BasePagination from '@/components/BasePagination'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'roleMana',
  components: {
    BasePagination,
  },
  computed: {
    ...mapState([
      'selectedSystem',
    ]),
  },
  data () {
    return {
      dialogType: '',
      addDialogVisible: false,
      addDialogTitle: '',
      // 新增数据
      id: '',
      platformId: '',
      name: '',
      description: '',
      state: '',
      sort: '',
      // 状态配置项
      stateOptions: [
        {
          value: true,
          label: '启用',
        },
        {
          value: false,
          label: '禁用',
        },
      ],
      // 列表数据
      listData: [],
      // 分页信息
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      // 搜索
      searchName: '',
      searchState: '',
      // 分配资源
      rid: '',
      distributionResourcesDialogVisible: false,
      resourcesOptions: [],
      selectedResources: [],
      reids: [],
      resourcesDefaultProps: {
        children: 'childs',
        label: 'name',
      },
      methodsOptions: [],
    }
  },
  watch: {
    // 监听平台选择
    selectedSystem (val) {
      if (val !== '') {
        this.initListData()
      }
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             详情
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    search () {
      this.pageIndex = 1
      this.initListData()
    },
    /**
     * @description             分配资源弹框
     * @param {Object}          角色信息
     * @return {undefined}      无返回值
     */
    async distributionResources (row) {
      this.rid = row.id
      this.distributionResourcesDialogVisible = true
      await this.getResourceMethodAll()
      this.getRolesResources(row.id)
    },
    /**
     * @description             获取角色资源信息
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    getRolesResources (id) {
      this.$http.get('/api/role/resource', {
        rid: id,
      }).then(res => {
        if (res.code === 'success') {
          let allResources = []
          let currentResources = []
          let reids = []
          res.data.allResources.map(item => {
            allResources = allResources.concat(item.modules)
          })
          this.resourcesDataProcessing(allResources)
          res.data.hasResources.map(k => {
            currentResources.push(k.id + ',' + k.method)
            reids.push(k.id)
          })
          this.resourcesOptions = allResources
          this.selectedResources = currentResources
          this.reids = reids
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description:  获取定义的资源
     * @param {*}
     * @return {*}
     */
    getResourceMethodAll () {
      return this.$http.get('/api/resource-method/all', { pid: this.selectedSystem }).then(res => {
        if (res.code === 'success') {
          this.methodsOptions = res.data.list.map(v => {
            return {
              value: v.id,
              label: v.descr,
              method: v.method,
            }
          })
        }
      })
    },
    /**
     * @description             资源数据处理
     * @param {Array}           资源数据
     * @return {undefined}      无返回值
     */
    resourcesDataProcessing (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type) {
          data[i].disabled = false
        } else {
          data[i].disabled = true
        }
        if (data[i].resources && data[i].resources.length) {
          data[i].resources.map(k => {
            const findData = this.methodsOptions.find(v => v.method === k.method) || {}
            data[i].childs.unshift({
              id: k.id + ',' + k.method,
              type: 'resources',
              name: findData.label,
              disabled: false,
            })
          })
        }
        if (data[i].childs && data[i].childs.length > 0) {
          this.resourcesDataProcessing(data[i].childs)
        }
      }
    },
    /**
     * @description             确认资源分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmDistributionResources () {
      let reidsArr = []
      this.reids.map(k => {
        reidsArr.push(k.split(',')[0])
      })
      this.$http.post('/api/role/resource', {
        rid: this.rid,
        reids: reidsArr.join(','),
      }).then(res => {
        if (res.code === 'success') {
          this.$message({
            type: 'success',
            message: '资源分配成功！',
          })
          this.distributionResourcesDialogVisible = false
          this.cancelDistributionResources()
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             取消资源分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDistributionResources () {
      this.distributionResourcesDialogVisible = false
      this.rid = ''
      this.resourcesOptions = []
      this.selectedResources = []
      this.reids = []
    },
    /**
     * @description             分配资源弹框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    distributionResourcesDialogClosed () {
      this.cancelDistributionResources()
    },
    /**
     * @description             资源选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    resourcesSelectChange (e1, e2) {
      let reids = []
      e2.checkedNodes.map(k => {
        reids.push(k.id)
      })
      this.reids = reids
    },
    /**
     * @description             新增用户按钮
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    add () {
      this.dialogType = 'add'
      this.addDialogTitle = '新增角色'
      this.addDialogVisible = true
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (row) {
      this.dialogType = 'detail'
      this.addDialogTitle = '平台详情'
      this.addDialogVisible = true
      this.id = row.id
      this.name = row.name
      this.description = row.description
      this.state = row.state
      this.sort = row.sort
    },
    /**
     * @description             编辑
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    modify (row) {
      this.dialogType = 'modify'
      this.addDialogTitle = '平台修改'
      this.addDialogVisible = true
      this.id = row.id
      this.name = row.name
      this.description = row.description
      this.state = row.state
      this.sort = row.sort
    },
    /**
     * @description             删除
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    deleteHandle (row) {
      this.$confirm('是否删除角色 - ' + row.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let params = {
          ids: row.id,
        }
        this.$http.post('/api/role/delete', params)
          .then(res => {
            if (res.code === 'success') {
              this.$notify({
                message: '删除成功！',
                type: 'success',
              })
              this.initListData()
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
      this.clearInfo()
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (this.name === '' || this.selectedSystem === '' || this.sort === '' || this.state === '') {
        this.$message({
          message: '请填写完整！',
          type: 'warning',
        })
        return
      }
      let params = {
        name: this.name,
        description: this.description,
        platformId: this.selectedSystem,
        sort: this.sort,
        state: this.state,
      }
      if (this.dialogType === 'modify') {
        params.id = this.id
      }

      this.$http.post('/api/role/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addDialogVisible = false
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.clearInfo()
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             置空填写信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      this.id = ''
      this.name = ''
      this.description = ''
      this.state = ''
      this.sort = ''
    },
    /**
     * @description             初始化列表数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    initListData () {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        platformId: this.selectedSystem,
        // name: this.searchName,
        // state: this.searchState,
      }
      this.$http.get('/api/role/list', params)
        .then(res => {
          if (res.code === 'success') {
            this.listData = res.data.list
            this.pageIndex = res.data.pageIndex
            this.total = res.data.total
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description: 当前页change事件
     * @param {Object} 事件对象
     * @return {undefined} 无返回值
     */
    currentChange (e) {
      this.pageIndex = e
      this.initListData()
    },
  },
  created () {
    this.setGlobalPlatformSelecter(true)
    if (this.selectedSystem) {
      this.initListData()
    }
  },
}
</script>

<style lang="less" scoped>
  .roleMana{
    width: 100%;
    height: 100%;

    .searchContainer {
      width: calc(100% - 40px);
      height: 50px;
      padding: 0 20px;
      position: relative;
      border-bottom: 1px solid rgb(241, 239, 239);

      .searchItem {
        display: inline-block;
        margin-right: 40px;
        .searchTitle {
          color: #666;
        }
        .el-input {
          width: 200px;
        }
      }

      .searchButton {
        float: right;
      }
    }

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .list {
        /deep/.el-table {
          .el-table__body-wrapper {
            .el-table__body {
              tbody {
                tr {
                  td {
                    padding: 18px 0;
                  }
                }
              }
            }
          }
        }
        .abnormal {
          color: #F56C6C;
        }
        .normal {
          color: #67C23A;
        }
        .handle{
          span {
            display: inline-block;
            width: 40px;
            text-decoration: underline;
            cursor: pointer;
          }
          .detail {
            color: #3890f2;
          }
          .enable {
            color: #67C23A;
          }
          .disable {
            color: #F56C6C;
          }
          .modify{
            color: #3890f2;
          }
          .distributionResources {
            color: #3890f2;
            width: 70px;
          }
          .modifyPassword {
            color: #3890f2;
            width: 70px;
          }
          .delete{
            color: #F56C6C;
          }
        }
      }

      .pagination {
        text-align: center;
        padding: 40px 0 0 0;
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 640px;
        height: 480px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 100%;
              margin: 18px 10px;
              .title {
                display: inline-block;
                width: 90px;
                text-align: right;
                .required {
                  color: #F56C6C;
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
              .el-input {
                width: 220px;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }
    /deep/.distributionUserResourcesDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 90%;
            position: relative;
            overflow-y: scroll;
            .el-select {
              width: 400px;
            }
            .is-disabled {
              display: none !important;
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
  }
</style>
